<div
  class="flex flex-col gap-2 text-sm  {{
    colorClass[color] || 'text-textPrimary'
  }}"
>
  <label
    class="{{ labelPrimary ? 'text-primary' : 'text-textPrimary' }}"
    *ngIf="label"
    for="{{ id }}"
    >{{ label }}</label
  >
  <p-dropdown
    *ngIf="!multiSelect"
    id="{{ id }}"
    [options]="options"
    [(ngModel)]="value"
    optionLabel="label"
    [showClear]="clearable"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [appendTo]="appendTo ? 'body' : ''"
    [editable]="editable"
    [required]="required"
    [filter]="filter"
    [optionValue]="defaultValue"
    [virtualScroll]="virtualScroll"
    [virtualScrollItemSize]="virtualScrollItemSize"
    [virtualScrollOptions]="virtualOptions"
    styleClass="{{ helperText ? 'border-[#ff0000]' : '' }} {{
      colorClass[color]
    }} {{ !dense ? 'py-2' : 'py-1' }} {{
      fullWidth ? 'w-full' : ''
    }} rounded-lg text-textPrimary"
    class="{{ helperText ? 'border-red-900' : '' }}"
    scrollHeight="300px"
    (onFilter)="onFilter($event)"
    (onChange)="onChange($event)"
  ></p-dropdown>

  <p-multiSelect
    *ngIf="multiSelect"
    id="{{ id }}"
    [options]="options"
    [(ngModel)]="value"
    optionLabel="label"
    [showClear]="clearable"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [optionValue]="defaultValue"
    styleClass="{{ helperText ? 'border-[#ff0000]' : '' }} {{
      !dense ? 'py-2' : 'py-1'
    }} {{ fullWidth ? 'w-full' : '' }} rounded-lg text-textPrimary"
    scrollHeight="300px"
    [showToggleAll]="false"
    (onChange)="onMultiSelectChange($event)"
    [appendTo]="'body'"
    overlayPosition="bottom"
  >
    <ng-template pTemplate="header">
      <input
        type="checkbox"
        [id]="id"
        [checked]="checkAll"
        class="mr-2 h-5 w-5 cursor-pointer rounded-sm border-2 border-gray-500"
        (click)="onToggleAllClicked($event)"
      />
    </ng-template>
  </p-multiSelect>

  <small *ngIf="helperText" class="text-[#ff0000]">{{ helperText }}</small>
</div>
